import UserAPI from '@/user/api/UserAPI';

export default class APIDriver {
  userAPI: UserAPI;

  constructor() {
    this.userAPI = new UserAPI();
  }

  get(key: string) {
    return this.userAPI.fetchSettingsByKey(key).then((res) => res.data);
  }

  set(key: string, value: unknown) {
    const nestedObjectBasedOnKey = {};
    const keyChain = key.split('.');

    keyChain.reduce((accamulator: Record<string, unknown>, subkey, i) => {
      accamulator[subkey] = i === keyChain.length - 1 ? value : {};

      return accamulator[subkey] as Record<string, unknown>;
    }, nestedObjectBasedOnKey);

    return this.userAPI.patchSettings(nestedObjectBasedOnKey);
  }

  // todo
  onKeyChange() {}
}
